import { customerMarketShopfrontJobsApi } from '@envato/foundation-types'
import axiosVerbose from '../../utils/axios/axiosVerbose'
import { ThunkAction } from 'redux-thunk'

import { IRootState } from '../../reducers'
import { logError } from '../../utils/errors'

export enum TypeKeys {
  GET_NEWEST_ITEMS_BY_CATEGORY_PENDING = 'GET_NEWEST_ITEMS_BY_CATEGORY_PENDING',
  GET_NEWEST_ITEMS_BY_CATEGORY_SUCCESS = 'GET_NEWEST_ITEMS_BY_CATEGORY_SUCCESS',
  GET_NEWEST_ITEMS_BY_CATEGORY_FAIL = 'GET_NEWEST_ITEMS_BY_CATEGORY_FAIL'
}

interface IPendingPayload {
  readonly category: string
}

interface ISuccessPayload {
  readonly category: string
  readonly searchResults: Readonly<
    customerMarketShopfrontJobsApi.INewestItemsResult
  >
}

export interface IGetNewestItemsByCategoryPendingAction {
  readonly type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_PENDING
  readonly payload: IPendingPayload
}

export interface IGetNewestItemsByCategorySuccessAction {
  readonly type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_SUCCESS
  readonly payload: ISuccessPayload
}

export interface IGetNewestItemsByCategoryFailAction {
  readonly type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_FAIL
}

export type ActionTypes =
  | IGetNewestItemsByCategoryPendingAction
  | IGetNewestItemsByCategorySuccessAction
  | IGetNewestItemsByCategoryFailAction

export const fetchNewestItemsByCategory = (
  category: string
): ThunkAction<
  Promise<
    IGetNewestItemsByCategorySuccessAction | IGetNewestItemsByCategoryFailAction
  >,
  IRootState,
  any
> => {
  return (dispatch, getState) => {
    const { currentSite } = getState().common

    dispatch({
      payload: { category },
      type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_PENDING
    })
    const categoryName = category === 'all' ? 'index' : category
    const newestItemPath = `shopfront-api/newest_items_by_category/${currentSite}/${categoryName}`
    return axiosVerbose
      .get<customerMarketShopfrontJobsApi.INewestItemsResult>(newestItemPath)
      .then(response => {
        const successAction: IGetNewestItemsByCategorySuccessAction = {
          payload: { searchResults: response.data, category },
          type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_SUCCESS
        }
        return dispatch(successAction)
      })
      .catch(err => Promise.reject(logError(err)))
      .catch(() => {
        const failAction: IGetNewestItemsByCategoryFailAction = {
          type: TypeKeys.GET_NEWEST_ITEMS_BY_CATEGORY_FAIL
        }
        return dispatch(failAction)
      })
  }
}
